## Visão geral

Não existe um endpoint separado de login na API pública.

A autenticação acontece em toda chamada pública por meio do header `Authorization`, usando um bearer token vinculado à organização no formato:

`Authorization: Bearer ctt_live_<key_id>.<secret>`

## Header obrigatório

- `Authorization` (`string`, obrigatório): bearer token completo emitido na criação ou rotação da credencial.
- Prefixo aceito: `Bearer`.
- Prefixo do token: `ctt_live_`.
- Não envie `X-Tenant-Id` nem headers de troca de contexto: a organização é resolvida pela própria credencial.

## Como obter uma chave

Acesse [Minha conta > API pública](/account?tab=settings&settings_tab=public_api) e crie uma credencial para a integração.

Na criação ou rotação, a tela mostra o bearer token completo uma única vez. Guarde o valor completo em um cofre de segredo. Depois disso, a plataforma exibe apenas o `key_id` e os últimos 4 caracteres do segredo.

A área de API pública aparece apenas para organizações com assinatura ativa em um plano que habilita API pública.

## Exemplo mínimo para validar a credencial

O exemplo abaixo usa `GET /public/v1/meta/tenant/` porque ele é o smoke test mais simples para provar que:

- o bearer foi enviado corretamente;
- a credencial ainda está ativa;
- a allowlist/IP está correta;
- a integração está autenticando na organização esperada.

<ApiCodeExamples exampleId="metaTenant" />

<ApiResponseExamples exampleId="metaTenant" />

## Como interpretar os principais erros

- `200 OK`: a credencial autenticou e o endpoint aceitou a chamada.
- `401 Unauthorized`: token ausente, malformado, inválido, expirado, revogado ou recusado pela allowlist de IP.
- `403 Forbidden`: a credencial autenticou, mas não tem o escopo exigido pelo endpoint.
- `429 Too Many Requests`: a credencial excedeu o rate limit configurado para a janela atual.

## Regras operacionais da credencial

- Cada credencial pertence a uma única organização.
- O segredo bruto é exibido apenas no momento de criação ou rotação.
- `allowed_ips`, quando configurado, restringe a chamada ao IP de origem listado.
- `expires_at`, quando preenchido, invalida a credencial a partir daquele instante.
- O throttling é aplicado por credencial, não por usuário humano.

## Escopos

- `campaigns.read`: leitura de campanhas públicas.
- `calls.read`: leitura de chamadas públicas.
- `calls.write`: criação de chamadas outbound com agente de IA.
- `agents.read`: leitura do catálogo de agentes de IA roteáveis.
- `scripts.read`: leitura do catálogo de scripts relacionados a chamadas.
- `users.read`: leitura do catálogo de usuários para transferência.
- `transfer_groups.read`: leitura do catálogo de grupos de transferência.

## Boas práticas

- valide a credencial com `GET /public/v1/meta/tenant/` logo após criar ou rotacionar o token;
- use uma credencial por integração, em vez de compartilhar o mesmo token entre sistemas diferentes;
- conceda apenas os escopos necessários para aquela integração;
- trate `401`, `403` e `429` separadamente no cliente, porque eles representam problemas diferentes.
